import type { TOC } from '@ember/component/template-only';
import { PrismBadge, PrismIllustration } from '@mylighthouse/prism-ember';
import type { BadgeType } from '@mylighthouse/prism-ember/types/components/prism/badge';
import type { IllustrationName } from '@mylighthouse/prism-ember/types/components/prism/illustration';
import { t } from 'ember-intl';
import type { AccountType } from 'lumen/services/navigation';
import { SUBSCRIPTION_TYPE_TRANSLATION_KEYS } from 'lumen/utils/constants/general-constants';

import styles from './account-selection-card.module.css';
import GeneralButtonsChoiceSegmentButton from './buttons/choice-segment-button';

const ACCOUNT_ILLUSTRATIONS: Record<AccountType, IllustrationName> = {
  brand: '100x100_balance',
  business: '100x100_binoculars',
  chain: '100x100_flowchart',
  hotel: '100x100_hotel',
};

interface GeneralAccountSelectionCardSignature {
  Args: {
    accountType: AccountType;
    badgeLabel?: string;
    badgeType?: BadgeType;
    isSelected?: boolean;
    onClick: () => void;
    subLabel?: string;
    subLabel2?: string;
  };
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getIllustration = (accountType: AccountType) =>
  ACCOUNT_ILLUSTRATIONS[accountType];

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getLabelKey = (accountType: AccountType) =>
  SUBSCRIPTION_TYPE_TRANSLATION_KEYS[accountType];

const GeneralAccountSelectionCard = <template>
  <GeneralButtonsChoiceSegmentButton
    @isChecked={{if @isSelected true false}}
    @label={{t (getLabelKey @accountType)}}
    @onClick={{@onClick}}
    @subLabel={{@subLabel}}
    @subLabel2={{@subLabel2}}
    @type="radio"
    class="items-center {{styles.card}}"
    data-test-account-selection={{@accountType}}
  >
    <PrismIllustration @name={{getIllustration @accountType}} @size="medium" />
    {{#if @badgeType}}
      <PrismBadge @label={{@badgeLabel}} @type={{@badgeType}} />
    {{/if}}
  </GeneralButtonsChoiceSegmentButton>
</template> satisfies TOC<GeneralAccountSelectionCardSignature>;

export default GeneralAccountSelectionCard;
